
import React from "react";
import { plans } from "../data/pricing";

function Pricing() {
  return (
    <section className="w-full bg-slate-950 px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">

        {/* Title */}
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Plans simples et transparents
          </h2>

          <p className="mt-4 text-base text-gray-400 sm:text-lg">
            Pas de frais cachés, annulez quand vous voulez
          </p>
        </div>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`
                relative flex flex-col
                rounded-2xl
                border
                p-6
                transition-all duration-300
                hover:-translate-y-2
                hover:shadow-2xl
                ${
                  plan.highlighted
                    ? "border-blue-500 bg-blue-950/40 shadow-xl shadow-blue-500/10"
                    : "border-white/10 bg-white/5"
                }
              `}
            >
              {/* Popular Badge */}
              {plan.highlighted && (
                <div
                  className="
                    absolute -top-4 left-1/2
                    -translate-x-1/2
                    whitespace-nowrap
                    rounded-full
                    bg-blue-600
                    px-4 py-1.5
                    text-xs font-semibold
                    text-white
                    shadow-lg
                  "
                >
                  Plus populaire
                </div>
              )}

              {/* Plan Name */}
              <h3
                className={`
                  text-center text-xl font-bold
                  ${
                    plan.highlighted
                      ? "text-blue-400"
                      : "text-white"
                  }
                `}
              >
                {plan.name}
              </h3>

              {/* App */}
              <h3 className="mt-2 text-center text-sm font-medium text-gray-400">
                {plan.app}
              </h3>

              {/* Price */}
              <div
                className={`
                  mt-6 text-center text-4xl font-extrabold
                  ${
                    plan.highlighted
                      ? "text-blue-400"
                      : "text-white"
                  }
                `}
              >
                {plan.price}€
              </div>

              {/* Features */}
              <ul className="mt-8 flex flex-1 flex-col gap-4">
                {plan.features.map((feature, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-3 text-sm text-gray-300"
                  >
                    <span
                      className="
                        mt-0.5
                        flex h-5 w-5
                        flex-shrink-0
                        items-center justify-center
                        rounded-full
                        bg-green-500/10
                        text-sm font-bold
                        text-green-400
                      "
                    >
                      ✓
                    </span>

                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Button */}
              <button
                type="button"
                onClick={() =>
                  window.open(
                    "https://wa.me/447308508638",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
                className={`
                  mt-8 w-full
                  rounded-xl
                  px-5 py-3
                  text-sm font-semibold
                  text-white
                  transition-all duration-300
                  ${
                    plan.highlighted
                      ? "bg-blue-600 hover:bg-blue-500 shadow-lg shadow-blue-600/20"
                      : "bg-white/10 hover:bg-white/20"
                  }
                `}
              >
                Choisir ce plan
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Pricing;
